import { Injectable, OnDestroy } from '@angular/core';
import { CheckinBaseClass } from '../../components';
import {
  GetOrderResultState,
  resetGetOrderResult,
  selectGetOrderResult,
  selectGetOrderResultIsFailureStatus,
  selectGetOrderResultState,
  setGetOrderResultFromApi,
} from '../../store/get-order-result';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GetOrderRequest, GetOrderResponse, DefaultService as Api } from 'src/sdk-servicing';

@Injectable()
export class GetOrderResultStoreService extends CheckinBaseClass {
  private _result$: Observable<GetOrderResultState>;
  private _result!: GetOrderResultState;
  get result() {
    return this._result;
  }

  constructor(private _store: Store<GetOrderResultState>, private api: Api) {
    super();
    this._result$ = this._store.pipe(
      select(selectGetOrderResultState),
      filter((data) => !!data)
    );
    this.subscribeService(this._result$, (data) => {
      this._result = data;
    });
  }

  override destroy(): void {}

  /**
   * GetOrderResultStateStore のObservableを返却する
   * @returns GetOrderResultStateStore の全ての値を取得するObservable
   */
  public getResultState$() {
    return this._result$;
  }

  /**
   * GetOrderStoreのAPIのレスポンス部分のObservableを返却する
   * @returns GetOrderStoreのレスポンス部分を取得するObservable
   */
  public getResponse$() {
    return this._store.pipe(select(selectGetOrderResult));
  }

  /**
   * エラーが発生しているPNR情報取得APIのレスポンス通知
   */
  get failure$() {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  /**
   * API呼び出し結果のObservableを受け取りStoreに格納する
   * @param call API呼び出し結果を取得するObservable
   */
  public setResult(call: Observable<GetOrderResponse>) {
    this._store.dispatch(setGetOrderResultFromApi({ call }));
  }

  /**
   * PNR情報取得APIを呼び出す
   * @param parameter PNR情報取得APIのリクエストパラメータ
   */
  callApi(parameter: GetOrderRequest): void {
    const call = this.api.ordersGetOrderPost(parameter);
    this.setResult(call);
  }

  /**
   * PNR情報取得結果ストアをクリアする
   */
  clear(): void {
    this._store.dispatch(resetGetOrderResult());
  }
}
